<template>
  <slot v-bind="self"/>
</template>

<script>
  import _ from 'lodash'
  import TextCounter from './text-counter'

  export default {
    name: 'CountableField',
    components: {
      'text-counter': TextCounter,
    },
    props: [
      'maxLength',
      'initValue',
      'class',
      'style',
      'key'
    ],
    data () {
      return {
        value: this.initValue
      }
    },
    mounted () {
    },
    computed: {
      self() {
        return this;
      },
      wordCount () {
        return _.toString(this.value || '').replace(/\r\n/g, "\n").length
      },
    }
  }
</script>
